import { useEffect, useState } from 'react'
import { isEnglish } from '../lib/i18n'
import './EnvironmentBadge.css'

const ENVIRONMENTS = {
  DEV: { en: 'DEV', ar: 'تطوير (DEV)' },
  DEVELOPMENT: { en: 'DEV', ar: 'تطوير (DEV)' },
  QA: { en: 'QA', ar: 'اختبار (QA)' },
  TEST: { en: 'QA', ar: 'اختبار (QA)' },
  TESTING: { en: 'QA', ar: 'اختبار (QA)' },
  PROD: null,
  PRODUCTION: null,
}

function formatEnvironmentLabel(label) {
  const value = String(label ?? '').trim().slice(0, 24)
  if (!value) return ''

  const environment = ENVIRONMENTS[value.toUpperCase()]
  if (environment === null) return ''
  if (environment) return isEnglish ? environment.en : environment.ar

  return value
}

/**
 * Runtime deployment marker. The same image can serve development and production:
 * the server returns an empty label in production, so no marker is rendered there.
 */
export default function EnvironmentBadge() {
  const [label, setLabel] = useState('')

  useEffect(() => {
    const controller = new AbortController()

    fetch('/api/environment', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
      signal: controller.signal,
    })
      .then((response) => (response.ok ? response.json() : null))
      .then((payload) => setLabel(formatEnvironmentLabel(payload?.label)))
      .catch((error) => {
        if (error.name !== 'AbortError') setLabel('')
      })

    return () => controller.abort()
  }, [])

  if (!label) return null

  return (
    <div className="environment-badge" role="status" aria-label={`${label} environment`}>
      {label}
    </div>
  )
}
